import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { environment } from '../environments/environment';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'appcheck-init',
    loadComponent: () => import('@shared').then(m => m.AppCheckInitComponent),
    data: { siteKey: environment.appCheck?.siteKey, defaultHref: '/dashboard' }
  },
  {
    path: '**',
    loadComponent: () => import('@shared').then(m => m.NotFoundComponent),
    data: { toolbarColor: 'storm-blue', homeRoute: '/dashboard' }
  }
];
